import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import setRequestQuoteModalParams from "@MasterBluePrint/Store/Components/RequestQuoteModal/Handlers/SetRequestQuoteModalParams";
import { MasterState } from "@MasterBluePrint/Store/MasterState";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    enableThirdPartyCode = "enableThirdPartyCode",
    scriptSrc = "scriptSrc",
    formID = "formID",
    loadFormParam1 = "loadFormParam1",
    loadFormParam2 = "loadFormParam2",
    loadFormParam3 = "loadFormParam3",
    loadFormRedirectUrl = "loadFormRedirectUrl",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.enableThirdPartyCode]: boolean;
        [fields.scriptSrc]: string;
        [fields.formID]: string;
        [fields.loadFormParam1]: string;
        [fields.loadFormParam2]: string;
        [fields.loadFormParam3]: string;
        [fields.loadFormRedirectUrl]: string;
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: MasterState) => {
    const { paramThree, paramTwo, paramOne, formId } = state.requestQuoteModal;
    return {
        formId,
        paramOne,
        paramTwo,
        paramThree,
    };
};

const mapDispatchToProps = {
    setRequestQuoteModalParams,
};

export const LoadExternalScript = ({ setRequestQuoteModalParams, fields }: Props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const marketoScriptId = "mktoForms";

    useEffect(() => {
        if (fields.enableThirdPartyCode && isLoaded === false) {
            loadScript();
            setRequestQuoteModalParams({
                paramThree: fields.loadFormParam3,
                paramTwo: fields.loadFormParam2,
                paramOne: fields.loadFormParam1,
                formId: fields.formID,
            });
        }
    }, []);

    const loadScript = () => {
        if (fields.enableThirdPartyCode && isLoaded === false) {
            const scriptCall = document.getElementById(marketoScriptId);
            if (scriptCall !== null) {
                scriptCall.remove();
            }
            const s = document.createElement("script");
            s.id = "MktoFormsScript";
            s.id = marketoScriptId;
            s.type = "text/javascript";
            s.async = true;
            s.src = fields.scriptSrc;
            s.onload = () => setIsLoaded(true);
            document.getElementsByTagName("head")[0].appendChild(s);
        }
    };

    return <></>;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(LoadExternalScript),
    definition: {
        group: "Basic",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.enableThirdPartyCode,
                displayName: "Enable Third Party Code Injection?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Translatable",
            },
            {
                fieldType: "General",
                name: fields.scriptSrc,
                editorTemplate: "TextField",
                displayName: "Script Src",
                defaultValue: "//313-KJQ-147.mktoweb.com/js/forms2/js/forms2.min.js",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.formID,
                editorTemplate: "TextField",
                displayName: "Form ID",
                defaultValue: "mktoForm_5896",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormParam1,
                editorTemplate: "TextField",
                displayName: "Load Form Param 1",
                defaultValue: "//313-KJQ-147.mktoweb.com",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormParam2,
                editorTemplate: "TextField",
                displayName: "Load Form Param 2",
                defaultValue: "313-KJQ-147",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormParam3,
                editorTemplate: "TextField",
                displayName: "Load Form Param 3",
                defaultValue: "5896",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
            {
                fieldType: "General",
                name: fields.loadFormRedirectUrl,
                editorTemplate: "TextField",
                displayName: "Redirect URL",
                defaultValue: "",
                isVisible: widget => widget.fields.enableThirdPartyCode,
            },
        ],
    },
};
export default widgetModule;
